import React from 'react'
import {objectLang, setLocalStorageItem} from "../functions"

export const PolicyPage = ({language}) => {
    setLocalStorageItem('page', 'PolicyPage')

    let lang = objectLang().language
    if (language && language === 'en') {
        lang = objectLang().languages.en
    }
    return (
        <>
            <div className={'container'}>
                <h1 className={'mt-4 text-center'}>{lang.policy.title}</h1>
                <div className={'col col-xl-8 col-12 m-auto'}>
                    <p className={'mt-4 text-start'}>{lang.policy.date}</p>
                    <p className={'text-start'}>{lang.policy.desc}</p>
                    <h4 className={'mt-4 text-start'}>{lang.policy.par_1.title}</h4>
                    <p className={'ps-4 ms-1 text-start'}>{lang.policy.par_1.str_1}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_1.str_2}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_1.str_3}</p>
                    <p className={'ps-4 ms-1 text-start'}>{lang.policy.par_1.str_4}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_1.str_5}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_1.str_6}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_1.str_7}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_1.str_8}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_1.str_9}</p>
                    <h4 className={'mt-4 text-start'}>{lang.policy.par_2.title}</h4>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_2.str_1}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_2.str_2}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_2.str_3}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_2.str_4}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_2.str_5}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_2.str_6}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_2.str_7}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_2.str_8}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_2.str_9}</p>
                    <h4 className={'mt-4 text-start'}>{lang.policy.par_3.title}</h4>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_3.str_1}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_3.str_2}</p>
                    <h4 className={'mt-4 text-start'}>{lang.policy.par_4.title}</h4>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_4.str_1}</p>
                    <a className={'ps-4 ms-1 m-0 text-start'} href={`mailto:${lang.policy.par_4.email}`}>{lang.policy.par_4.email}</a>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_4.str_2}</p>
                    <h4 className={'mt-4 text-start'}>{lang.policy.par_5.title}</h4>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_5.str_1}</p>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_5.str_2}</p>
                    <h4 className={'mt-4 text-start'}>{lang.policy.par_6.title}</h4>
                    <p className={'ps-4 ms-1 m-0 text-start'}>{lang.policy.par_6.str_1}</p>
                    <a className={'ps-4 ms-1 m-0 text-start'} href={`mailto:${lang.policy.par_4.email}`}>{lang.policy.par_4.email}</a>
                    <p/>
                </div>
            </div>
        </>
    )
}
